<div class="cb-alert-card cb-agree-to-condition flex-row"
     [ngClass]="{'warning' : !value, 'disabled': disabled && !value }"
     style="padding-left: 10px;">
    @if (!readonly) {
        <mat-checkbox class="flex"
                      [color]="color()"
                      [ngClass]="{'read-only': readonly, 'mat-form-field': !slim}"
                      [name]="internalName"
                      [(ngModel)]="value"
                      [required]="required"
                      [indeterminate]="indeterminate"
                      [labelPosition]="labelPosition"
                      [disabled]="disabled">
            {{ label }}
            <ng-content></ng-content>
        </mat-checkbox>
    }
    @if (readonly) {
        <mat-checkbox class="flex"
                      [ngClass]="{'read-only': readonly, 'mat-form-field': !slim}"
                      [checked]="value"
                      [disableRipple]="true"
                      [disabled]="true">
            {{ label }}
            <ng-content></ng-content>
        </mat-checkbox>
    }
</div>
